import type { Meta } from '@brighterly/lib-core-types/api/interfaces'
import type { AssignmentTemplateListRow } from '../../assignments/interfaces'
import type { AssignmentTemplatesStore } from './interfaces'

import { isFullArray } from '@shared/lib/collections'

const getMeta = (state: AssignmentTemplatesStore): Meta | null => state.templatesPaginatedData?.meta || null
const getTemplates = (state: AssignmentTemplatesStore): AssignmentTemplateListRow[] => state.templatesPaginatedData?.templates || []

export const getters = {
  isLoading: (state: AssignmentTemplatesStore): AssignmentTemplatesStore['loading'] => state.loading,
  getTemplates: (state: AssignmentTemplatesStore): AssignmentTemplateListRow[] => getTemplates(state),
  hasTemplates: (state: AssignmentTemplatesStore): boolean => isFullArray(getTemplates(state)),
  getFilterSearch: (state: AssignmentTemplatesStore): AssignmentTemplatesStore['filterSearch'] => state.filterSearch,
  getFilterType: (state: AssignmentTemplatesStore): AssignmentTemplatesStore['filterType'] => state.filterType,
  getFilterDisciplineCode: (state: AssignmentTemplatesStore): AssignmentTemplatesStore['filterDisciplineCode'] => state.filterDisciplineCode,
  getFilterGrade: (state: AssignmentTemplatesStore): AssignmentTemplatesStore['filterGrade'] => state.filterGrade,
  getFilterModuleId: (state: AssignmentTemplatesStore): AssignmentTemplatesStore['filterModuleId'] => state.filterModuleId,
  hasFilters: (state: AssignmentTemplatesStore): boolean =>
    state.filterSearch !== null
    || state.filterType !== null
    || state.filterDisciplineCode !== null
    || state.filterGrade !== null
    || state.filterModuleId !== null,
  getMeta: (state: AssignmentTemplatesStore): Meta | null => getMeta(state),
  getCurrentPage: (state: AssignmentTemplatesStore): AssignmentTemplatesStore['currentPage'] => state.currentPage,
  getPerPage: (state: AssignmentTemplatesStore): AssignmentTemplatesStore['perPage'] => state.perPage,
  getLastPage: (state: AssignmentTemplatesStore): number => getMeta(state)?.last_page || 1,
  getTotal: (state: AssignmentTemplatesStore): number => getMeta(state)?.total || 0,
  // No `isModalCreate` getter — it would collide with the state field.
  isModalDelete: (state: AssignmentTemplatesStore): boolean => state.templateToDelete !== null,
  isModalDuplicate: (state: AssignmentTemplatesStore): boolean => state.templateToDuplicate !== null,
  getTemplateToDelete: (state: AssignmentTemplatesStore): AssignmentTemplatesStore['templateToDelete'] => state.templateToDelete,
  getTemplateToDuplicate: (state: AssignmentTemplatesStore): AssignmentTemplatesStore['templateToDuplicate'] => state.templateToDuplicate,
}
